import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createLesson, toggleFormLesson } from '../../../../../redux/actions/lessons'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'
import { FormElement, ILessonEditor, UseLessonEditorParams } from '../../models/lessons'

export const useLessonEditor = ({ courseId, courseLastOrder }: UseLessonEditorParams) => {
  const dispatch = useDispatch()
  const { lesson_selected, confirm, showForm } = useSelector((state: IRootState) => state.lesson)
  const { isValidForm, errorForm, errorTab, msgForm } = useSelector((state: IRootState) => state.validator)

  const [lessonState, setLessonState] = useState<ILessonEditor>({
    id: null,
    fileNames: [],
    courseId: courseId,
    title: '',
    content: '',
    order: (courseLastOrder ?? 0) + 1,
    duration: 1,
    notifications: { email: 0, notification: 0, integration: 0, hierarchy: 0 }
  })

  const [minOrder, setMinOrder] = useState(1)

  useEffect(() => {
    if (lesson_selected != null) {
      setLessonState({
        id: lesson_selected.id,
        fileNames: [],
        courseId: lesson_selected.course.id,
        title: lesson_selected.title,
        content: lesson_selected.content,
        order: lesson_selected.order,
        duration: lesson_selected.duration,
        notifications:
          lesson_selected.notifications !== null
            ? JSON.parse(lesson_selected.notifications)
            : { email: 0, notification: 0, integration: 0, hierarchy: 0 }
      })
    }
  }, [lesson_selected])

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())
      dispatch(createLesson(lessonState))
    }
  }, [isValidForm, dispatch, lessonState])

  const handleInputChange = (inputName: string, value: any) => {
    console.log('handleInputChange', inputName, value)
    setLessonState(prevState => ({ ...prevState, [inputName]: value }))
  }

  const handleEditorChange = (e: any) => {
    console.log('handleEditorChange', e.target.getContent())
    setLessonState(prevState => ({ ...prevState, content: e.target.getContent() }))
  }

  const handleNotificationsChange = (inputName: string) => (event: FormElement) => {
    let value: any
    if (inputName === 'hierarchy') {
      value = event.target.value
    } else {
      value = event.target.checked
    }

    setLessonState(prevState => ({
      ...prevState,
      notifications: {
        ...prevState.notifications,
        [inputName]: value
      }
    }))
  }

  const handleSubmit = () => {
    dispatch(
      formValidator({
        title: [lessonState.title, 'required|max:50|min:2'],
        courseId: [lessonState.courseId, 'required|numeric'],
        content: [lessonState.content, 'notempty', 'general'],
        order: [lessonState.order, 'required|numeric|min:1'],
        duration: [lessonState.duration, 'required|numeric|min:1']
      })
    )
  }

  const handleConfirmSubmit = () => {
    console.log('lessonState')
    console.log(lessonState)
    dispatch(
      createLesson({
        ...lessonState,
        confirmOrder: lesson_selected?.order ? lesson_selected.order : courseLastOrder + 1
      })
    )
  }

  const getUploadParams = ({ meta }: any) => {
    setLessonState(prevState => ({
      ...prevState,
      fileNames: [...prevState.fileNames, meta.name]
    }))
    return {
      url: `${import.meta.env.VITE_API_URL}/lessons/uploaddropzone/${meta.name}`
    }
  }

  const handleCloseForm = () => {
    dispatch(toggleFormLesson())
  }

  return {
    lessonState,
    minOrder,
    lesson_selected,
    confirm,
    showForm,
    isValidForm,
    errorForm,
    errorTab,
    msgForm,
    handleInputChange,
    handleEditorChange,
    handleNotificationsChange,
    handleSubmit,
    handleConfirmSubmit,
    getUploadParams,
    handleCloseForm,
    setLessonState,
    setMinOrder
  }
}
